"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class ExpandIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "20px", height: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd", strokeLinecap: "square" },
                React.createElement("g", { stroke: fill },
                    React.createElement("g", { transform: "translate(4.000000, 7.000000)" },
                        React.createElement("path", { d: "M0.666666667,0.666666667 L6,6" }),
                        React.createElement("path", { d: "M11.3333333,0.666666667 L6,6" }))))));
    }
}
exports.ExpandIcon = ExpandIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/expand.tsx
// module id = 2143
// module chunks = 0 1 2